/**
 * Valores de wire de `painType` na API de sinais de prospecção.
 *
 * NÃO são os nomes do enum `ProspectPainType` do Prisma. O backend traduz
 * kebab-case -> enum em `PAIN_TYPE_MAP`; enviar `MANTER_DESENVOLVIMENTO`
 * resulta em 400. Estes são os valores que vão na querystring.
 */
export const PROSPECT_PAIN_TYPES = [
  'gerar-desenvolvimento',
  'manter-desenvolvimento',
  'outra-dor',
  'sem-dor',
] as const;

export type ProspectPainTypeValue = (typeof PROSPECT_PAIN_TYPES)[number];

export const PROSPECT_PAIN_TYPE_LABELS: Record<ProspectPainTypeValue, string> = {
  'gerar-desenvolvimento': 'Gerar desenvolvimento',
  'manter-desenvolvimento': 'Manter desenvolvimento',
  'outra-dor': 'Outra dor',
  'sem-dor': 'Sem dor',
};

/** Status de triagem aceito pelo filtro da listagem. */
export const PROSPECT_SIGNAL_STATUSES = ['pending', 'promoted', 'dismissed', 'all'] as const;

export type ProspectSignalStatus = (typeof PROSPECT_SIGNAL_STATUSES)[number];

export const PROSPECT_SIGNAL_STATUS_LABELS: Record<ProspectSignalStatus, string> = {
  pending: 'Pendentes',
  promoted: 'Promovidos',
  dismissed: 'Dispensados',
  all: 'Todos',
};
